import { useMutation, useQueryClient } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';
import type { CreateMenuRequest } from '../types/menu';

/**
 * POST /api/eraf/menus — 메뉴 생성
 * 성공 시 tree / flat 캐시 무효화
 */
export function useCreateMenu() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CreateMenuRequest) => menuApi.create(body),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['menu-management', 'tree'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'flat'] });
      void qc.invalidateQueries({ queryKey: ['menu-management', 'me'] });
      void qc.invalidateQueries({ queryKey: ['catalog'] });
    },
  });
}
